export const regions = {
  au: { name: 'Rest of World', code: 'au', hostname: AU_HOSTNAME },
  us: { name: 'North America', code: 'us', hostname: US_HOSTNAME },
}

export const VISITOR_REGION_MAP = {
  au: 'au',
  ca: 'us',
  us: 'us',
}

export const BASE_REGION = 'au'

export const KEY_NAMES = { visitorCountry: 'visitorCountry', selectedStore: 'selectedStore' }

export const COOKIE_DOMAIN = '.iamgia.com'
